import { render } from "./instructor-assignment-modal.vue?vue&type=template&id=14144e3b"
import script from "./instructor-assignment-modal.vue?vue&type=script&lang=js"
export * from "./instructor-assignment-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__